import { apiKeysReducerMap } from "@somewear/api-keys";
import { assetReducerMap, contactReducerMap, identityReducerMap } from "@somewear/asset";
import { authReducerMap } from "@somewear/auth";
import { biometricReducerMap } from "@somewear/biometric";
import { changelogReducerMap } from "@somewear/changelog";
import { clusterReducerMap } from "@somewear/cluster";
import {
	deviceReducerMap,
	deviceTransferReducerMap,
	queuedDeviceNameChangeReducerMap,
} from "@somewear/device";
import { featureReducerMap } from "@somewear/feature";
import { filesReducerMap } from "@somewear/files";
import { layerReducerMap } from "@somewear/layers";
import { mediaCommsReducerMap } from "@somewear/media-comms";
import { conversationsSlice, messagesReducerMap, messagingReducerMap } from "@somewear/messaging";
import { modelReducerMap, resetState, Sentry } from "@somewear/model";
import { notificationReducerMap, notificationsSlice } from "@somewear/notification";
import { organizationReducerMap } from "@somewear/organization";
import { sensorReducerMap } from "@somewear/sensors";
import { settingsReducerMap } from "@somewear/settings";
import { shapeReducerMap } from "@somewear/shapes";
import { sosReducerMap } from "@somewear/sos";
import { subscriptionReducerMap } from "@somewear/subscription";
import { waypointReducerMap } from "@somewear/waypoint";
import { workspaceReducerMap, workspacesSlice } from "@somewear/workspace";
import locationSlice from "@web/tracking/locations/location.slice";
import trackingRoutesSlice from "@web/tracking/routes/trackingRoutesSlice";
import trackingReducer from "@web/tracking/trackingSlice";
import type { Action } from "redux";
import { combineReducers } from "redux";

import workspaceDeviceSlice from "../settings/workspace/workspaceDevicesSlice";
import appSlice, { setGlobalError } from "./appSlice";

const appReducerMap = {
	app: appSlice.reducer,
	tracking: trackingReducer,
	conversations: conversationsSlice.reducer,
	workspaceDevices: workspaceDeviceSlice.reducer,
	notifications: notificationsSlice.reducer,
	workspaces: workspacesSlice.reducer,
	trackingRoutes: trackingRoutesSlice.reducer,
	locations: locationSlice.reducer,
};

const appReducers = combineReducers(appReducerMap);

export type AppState = ReturnType<typeof appReducers>;

export const mainReducer = combineReducers({
	...modelReducerMap,
	...appReducerMap,
	...apiKeysReducerMap,
	...changelogReducerMap,
	...shapeReducerMap,
	...authReducerMap,
	...sosReducerMap,
	...waypointReducerMap,
	...biometricReducerMap,
	...layerReducerMap,
	...organizationReducerMap,
	...mediaCommsReducerMap,
	...workspaceReducerMap,
	...queuedDeviceNameChangeReducerMap,
	...messagingReducerMap,
	...messagesReducerMap,
	...filesReducerMap,
	...deviceReducerMap,
	...deviceTransferReducerMap,
	...queuedDeviceNameChangeReducerMap,
	...identityReducerMap,
	...assetReducerMap,
	...contactReducerMap,
	...subscriptionReducerMap,
	...featureReducerMap,
	...settingsReducerMap,
	...clusterReducerMap,
	...sensorReducerMap,
	...notificationReducerMap,
});

/*
Define the RootState that can be accessed throughout the app
 */
export type RootState = ReturnType<typeof mainReducer>;

const rootReducer = (state: any, action: Action<string>): RootState => {
	if (action.type === resetState.type) {
		state = { redirect: state.redirect };
	}
	try {
		return mainReducer(state, action);
	} catch (e) {
		console.log(e);
		Sentry.captureException(e);
		return mainReducer(state, setGlobalError);
	}
};

export default rootReducer;
